/**
 * Markdown (clearance) plans API client (BFF: `/api/v1/catalog/pricing/markdown-plans`) —
 * epic-pricing-002 Phase 1, plan-platform-002 WP4.3. Confirmed live against
 * `web-merchant-portal-bff`'s `openapi.yml` (2026-09-03): create/list/get/activate/cancel.
 *
 * **Contract gap (disclosed):** there is no update endpoint (no
 * `PUT .../markdown-plans/{planId}`) — a DRAFT plan's product selection/steps cannot be edited
 * after creation, only viewed, activated or cancelled. `MarkdownPlansPanel`'s detail view is
 * therefore always read-only; getting a step wrong means cancelling (if activated) or simply
 * creating a new plan (if still DRAFT — there is no delete either, so a DRAFT plan is inert until
 * activated or cancelled).
 */
import { apiClient } from '@/shared/api';

import type {
  CreateMarkdownPlanRequest,
  ListMarkdownPlansParams,
  MarkdownPlanDetailResponse,
  MarkdownPlanResponse,
} from '../model/markdownPlanTypes';

const BASE = '/api/v1/catalog/pricing/markdown-plans';

export const listMarkdownPlans = async (
  params: ListMarkdownPlansParams = {},
): Promise<MarkdownPlanResponse[]> =>
  (await apiClient.get<MarkdownPlanResponse[]>(BASE, { params })).data;

export const createMarkdownPlan = async (
  body: CreateMarkdownPlanRequest,
): Promise<MarkdownPlanResponse> => (await apiClient.post<MarkdownPlanResponse>(BASE, body)).data;

export const getMarkdownPlan = async (planId: string): Promise<MarkdownPlanDetailResponse> =>
  (await apiClient.get<MarkdownPlanDetailResponse>(`${BASE}/${encodeURIComponent(planId)}`)).data;

export const activateMarkdownPlan = async (planId: string): Promise<MarkdownPlanResponse> =>
  (
    await apiClient.post<MarkdownPlanResponse>(`${BASE}/${encodeURIComponent(planId)}/activate`)
  ).data;

export const cancelMarkdownPlan = async (planId: string): Promise<MarkdownPlanResponse> =>
  (await apiClient.post<MarkdownPlanResponse>(`${BASE}/${encodeURIComponent(planId)}/cancel`)).data;
